import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles(theme => ({
  footer: {
//    marginTop: 'auto',
	height: "50px",
	color: "#FFF",
	backgroundColor: "#999",
	bottom: "0",
  },
}));

export default function Footer(props) {
	const classes = useStyles();
	let clase="";
	let conternt="";
	switch (props.multiplataforma) {
		case 'indra':
			clase = 'indra';
			conternt = <span>INDRA</span>
			break;
		case 'networkia':
			clase = 'networkia';
			conternt = <span>NETWORKIA</span>
			break;
		case 'devecl':
		default:
			clase = "ecl";
			conternt = <span>© EUROPEAN CONSULTANT LOBBY S.L.<br/>Av. Corts Catalanes, 5·7  I  08173 Sant Cugat del Vallès</span>
	}
	return (
		<footer className={clase}>
			{conternt}
		</footer>
	);
}